import React, { useState, useContext, useEffect, useRef } from "react";
import { ThemeContext } from "../../../../../../context/ThemeContext";
// import "../Styles/UserAccountGridLeft.css";
import ProfilePopover from "../../../../../common/ProfileButton/ProfilePopover";
import usePopover from "../../../../../../hooks/usePopover";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import UserBloggingNavigation from "../../../../../../hooks/navigateToUserBlogging";
import UserPostNavigation from "../../../../../../hooks/navigateToUserPosts";
import {
  faHome,
  faUsers,
  faCompass,
  faUserCircle,
  faBars,
  faUserFriends,
  faVideoCamera,
  faGlobe,
  faMagnifyingGlass,
  faShareNodes,
  faBookmark,
  faArchive,
  faPenToSquare,
  faRightFromBracket,
  faThumbtack,
  faGear,
  faLink,
  faArrowTrendUp,
  faBoltLightning,
} from "@fortawesome/free-solid-svg-icons";
import UserFriendsNavigation from "../../../../../../hooks/navigateToUserFriends";
import UserGroupsNavigation from "../../../../../../hooks/navigateToUserGroups";
import UserAccountReelsNavigation from "../../../../../../hooks/navigateToUserAccountReels";
import UserAccountExploreNavigation from "../../../../../../hooks/navigateToUserAccountExplore";
import UserAccountCommunityNavigation from "../../../../../../hooks/navigateToUserAccountCommunity";
import { useNavigate } from "react-router-dom";
import { FetchUserData } from "../Utils/UserFetchMockData";
import PropTypes from "prop-types";
import { logout } from "../../../../PublicLayout/SigninPage/auth"
import UserInstantsNavigation from "../../../../../../hooks/navigateToUserInstants";

const ReelsGridLeftLayout = ({ userId }) => {
  const {
    isOpen: isProfilePopoverOpen,
    openPopover: openProfilePopover,
    closePopover: closeProfilePopover,
    triggerRef: profileTriggerRef,
  } = usePopover();

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const { goToUserFriends } = UserFriendsNavigation(userId);
  const { goToUserBlogging } = UserBloggingNavigation();
  const { gotoUserPosts } = UserPostNavigation();
  const { goToUserGroups } = UserGroupsNavigation(userId);
  const { goToUserAccountReels } = UserAccountReelsNavigation(userId);
  const { goToUserAccountExplore } = UserAccountExploreNavigation(userId);
  const { goToUserAccountCommunity } = UserAccountCommunityNavigation(userId);
  const { goToUserAccountInstants } = UserInstantsNavigation(userId)

  const { theme } = useContext(ThemeContext);
  const [isExpanded, setIsExpanded] = useState(true);
  const [feedData, setFeedData] = useState([]);
  const [showMoreMenu, setShowMoreMenu] = useState(false);
  const moreButtonRef = useRef(null);
  const navigate = useNavigate();
  const [userName, setUserName] = useState("");
  const [hasCommunity, setHasCommunity] = useState(false);
  const [hasProfile, setHasProfile] = useState(false);

  useEffect(() => {
    const initialize = async () => {
      try {
        const data = await FetchUserData();
        if (data) setFeedData(data);
        else console.warn("No user data fetched.");
      } catch (err) {
        console.error("Error fetching user profiles:", err);
      }
    };
    initialize();
  }, []);

  const handleDeleteProfile = () => {
    setIsPopupOpen(true);
    closeProfilePopover();
  };

  const handleHomeClick = () => {
    navigate(`/user-feed/${userId}`); // ✅ Navigate to user-feed page
  };

  useEffect(() => {
    if (typeof setUserName !== "function") return;
    const first = feedData?.name?.firstName || "";
    const last = feedData?.name?.lastName || "";
    const full = [first, last].filter(Boolean).join(" ");
    if (full) setUserName(full);
  }, [feedData, setUserName]);

  useEffect(() => {
    // Fetch features list from localStorage
    const saved = localStorage.getItem("features");

    try {
      const features = saved ? JSON.parse(saved) : [];

      // Check feature flags
      setHasCommunity(features.includes("CD"));   // Enable community if CD exists
      setHasProfile(features.includes("IDN"));    // Enable profile if IDN exists

    } catch (err) {
      console.error("Invalid feature format in localStorage", err);
    }
  }, []);

  const goToUserTopTrends = () => {
    navigate("/top-trend")
  };  

  // --- Core Action Handlers ---
  const handlePostSelect = () => {
    navigate(`/user-feed/${userId}/post`); // ✅ Navigate to user-feed page
  };

    // --- Core Action Handlers ---
  const handleSuggestSelect = () => {
    navigate(`/user-feed/${userId}/suggested`); // ✅ Navigate to user-feed page
  };

  const handleSavedSelect = () => {
    navigate(`/user-feed/${userId}/saved`); // ✅ Navigate to user-feed page
  };

  const handleSharedSelect = () => {
    navigate(`/user-feed/${userId}/shared`); // ✅ Navigate to user-feed page
  };

  const handleArchiveSelect = () => {
    navigate(`/user-feed/${userId}/archive`); // ✅ Navigate to user-feed page
  };

  const handleSettingsSelect = () => {
    if (userId) {
      navigate(`/settings/${userId}`);
    }
    setShowMoreMenu(false);
  };

  const handleLogout = () => {
    setShowMoreMenu(false);
    localStorage.removeItem("session");
    localStorage.removeItem("userLoggedin");
    alert('You have been logged out.');
    // Implement your actual logout logic here, like clearing user data
      // Redirect to the login page
    logout()
    navigate('/'); // Assuming the login route is '/'
  };

  const handleSearchSelect = () => {
    setShowMoreMenu(false);
    navigate(`/search?type=localized`);
  };

  // Toggle More Menu
  const toggleMoreMenu = () => {
    setShowMoreMenu((prev) => !prev);
  };

  // Close menu when user clicks outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (moreButtonRef.current && !moreButtonRef.current.contains(event.target)) {
        setShowMoreMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleExploreSelect = () => {
    setShowMoreMenu(false);
    if (userId) {
      goToUserAccountExplore(userId);
    }
  };

  // --- Popup menu structure with action handlers ---
  const moreMenuOptions = [
    { label: "Post", handler: handlePostSelect, icon: faPenToSquare },
    { label: "Shared", handler: handleSharedSelect, icon: faLink },
    { label: "Suggested", handler: handleSuggestSelect, icon: faThumbtack },
    { label: "Saved", handler: handleSavedSelect, icon: faBookmark },
    { label: "Archived", handler: handleArchiveSelect, icon: faArchive },
    { label: "Explore", handler: handleExploreSelect, icon: faCompass },
    { label: "Settings", handler: handleSettingsSelect, icon: faGear },
    { label: "Search", handler: handleSearchSelect, icon: faMagnifyingGlass },
    { label: "Logout", handler: handleLogout, icon: faRightFromBracket },
  ];

  return (
    <div style={{ display: "flex", flexDirection: "column", position: "fixed" }}>
      <div style={{marginTop: 50}}>
        <div className="ap-sidebar-top">
          <button className="ap-option-container" onClick={handleHomeClick}>
            <FontAwesomeIcon icon={faHome} className="ua-icon-container" />
            {isExpanded && <span className="ap-label">Home</span>}
          </button>

          <button className="ap-option-container" onClick={goToUserFriends}>
            <FontAwesomeIcon icon={faUserFriends} className="ua-icon-container" />
            {isExpanded && <span className="ap-label">Friends</span>}
          </button>

          <button className="ap-option-container" onClick={goToUserGroups}>
            <FontAwesomeIcon icon={faUsers} className="ua-icon-container" />
            {isExpanded && <span className="ap-label">Groups</span>}
          </button>

          <button className="ap-option-container" onClick={goToUserAccountReels}>
            <FontAwesomeIcon icon={faVideoCamera} className="ua-icon-container" />
            {isExpanded && <span className="ap-label">Reels</span>}
          </button>

          <button className="ap-option-container" onClick={goToUserTopTrends}>
            <FontAwesomeIcon icon={faArrowTrendUp} className="ua-icon-container" />
            {isExpanded && <span className="ap-label">Trend</span>}
          </button>

          <button className="ap-option-container" onClick={goToUserAccountInstants}>
            <FontAwesomeIcon icon={faBoltLightning} className="ua-icon-container" />
            {isExpanded && <span className="ap-label">Instants</span>}
          </button>

          <button 
            className="ap-option-container" 
            onClick={hasCommunity ? goToUserAccountCommunity : undefined}
            disabled={!hasCommunity}
          >
            <FontAwesomeIcon icon={faGlobe} className="ua-icon-container" />
            {isExpanded && <span className="ap-label">Community</span>}
          </button>

          <button
            className="ap-option-container"
            onClick={
              hasProfile 
                ? () => (isProfilePopoverOpen ? closeProfilePopover() : openProfilePopover()) 
                : undefined
            }
            disabled={!hasProfile}
            ref={profileTriggerRef}
            style={{backgroundColor: "none"}}
          >
            <FontAwesomeIcon icon={faUserCircle} className="ua-icon-container" />
            {isExpanded && <span className="ap-label">Profile</span>}
          </button>

          <ProfilePopover
            isOpen={isProfilePopoverOpen}
            referenceElement={profileTriggerRef.current}
            onClose={closeProfilePopover}
            onDeleteProfile={handleDeleteProfile}
          />
        </div>

        <div className="ap-sidebar-bottom" >
          <div
            ref={moreButtonRef}
            style={{
              position: "relative",
              display: "flex",
              justifyContent: isExpanded ? "left" : "flex-start",
            }}
          >
            <button
              onClick={toggleMoreMenu}
              title="More"
              className="ap-more-button"
              style={{
                width: 30,
                height: 30,
                color: "white",
                background: "none",
                fontSize: 18,
                border: "none",
                marginLeft: "-70px",
                display: "flex",
                flexDirection: "row"
              }}
            >
              <FontAwesomeIcon icon={faBars} />
              <span
              className="cmn-text-label" 
              style={{marginTop: -5,
                fontSize: 18, 
                marginLeft: 0, 
                fontFamily: "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif"}}>Options </span>
            </button>

            {/* Popup Menu */}
            {showMoreMenu && (
              <div
                className="ap-popup-menu"
                style={{
                  position: "absolute",
                  bottom: "40px",
                  left: "0px",
                  background: "rgb(34, 31, 31)",
                  borderRadius: "8px",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
                  zIndex: 1000,
                  padding: "10px",
                  width: "180px",
                  color: "white",
                }}
              >
                {moreMenuOptions.map((option, i) => (
                  <div
                    key={i}
                    onClick={option.handler}
                    style={{
                      padding: "8px 10px",
                      cursor: "pointer",
                      borderRadius: "4px",
                      fontSize: "14px",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.background = "#333")}
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.background = "rgb(34, 31, 31)")
                    }
                  >
                    <FontAwesomeIcon icon={option.icon} />
                    {option.label}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReelsGridLeftLayout;
